<template>
  <GoogleAdsPopup
    path="/22777916944/RTMKlik_Web_Interstitial_Banner_640x480"
    :size="[640, 480]"
    id="div-gpt-ad-1690964945987-0"
    style="margin:0 auto;"
  />
</template>

<script>
import GoogleAdsPopup from "../../popup/googleAdsPopup.vue";
export default {
  data() {
    return {};
  },
  components: {
    GoogleAdsPopup,
  },
};
</script>

<style scoped></style>
